/* unplugin-vue-components disabled */import { render } from "./VideoDetails copy 2.vue?vue&type=template&id=19434653&scoped=true"
import script from "./VideoDetails copy 2.vue?vue&type=script&lang=js"
export * from "./VideoDetails copy 2.vue?vue&type=script&lang=js"

import "./VideoDetails copy 2.vue?vue&type=style&index=0&id=19434653&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19434653"]])

export default __exports__